import { css } from 'styled-components';
const createMediaQuery = (condition, breakpoint) => {
    return (first, ...interpolations) => {
        if (Array.isArray(first)) {
            return css `
        @media (${condition}: ${({ theme }) => theme.breakpoints[breakpoint]}px) {
          ${css(first, ...interpolations)}
        }
      `;
        }
        return css `
      @media (${condition}: ${({ theme }) => theme.breakpoints[breakpoint]}px) {
        ${css(first)}
      }
    `;
    };
};
export const media = {
    mobile: createMediaQuery('max-width', 'mobile'),
    tablet: createMediaQuery('max-width', 'tablet'),
    md: createMediaQuery('max-width', 'md'),
    l: createMediaQuery('max-width', 'l'),
    xl: createMediaQuery('max-width', 'xl'),
    xxl: createMediaQuery('max-width', 'xxl'),
    wide: createMediaQuery('max-width', 'wide'),
    ultra: createMediaQuery('max-width', 'ultra'),
};
export const mediaMin = {
    mobile: createMediaQuery('min-width', 'mobile'),
    tablet: createMediaQuery('min-width', 'tablet'),
    md: createMediaQuery('min-width', 'md'),
    l: createMediaQuery('min-width', 'l'),
    xl: createMediaQuery('min-width', 'xl'),
    xxl: createMediaQuery('min-width', 'xxl'),
    wide: createMediaQuery('min-width', 'wide'),
    ultra: createMediaQuery('min-width', 'ultra'),
};
export const mediaQuery = {
    lessThan: media,
    greaterThan: mediaMin,
};
